//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

export const getIsTiktokSparkAdsEnabled = createHasFeatureSelector(
  FeatureNames.TiktokSparkAds,
);

export const getIsTikTokSparkAdsViewsEnabled = createHasFeatureSelector(
  FeatureNames.TiktokAdViews,
);

export const getIsInstagramAdsContentAllowlistingEnabled =
  createHasFeatureSelector(FeatureNames.InstagramAdsContentAllowlisting);
